document.addEventListener("DOMContentLoaded", () => {
    function currencyFormSubmit(event) {
        event.target.form.submit();
    }

    document.querySelectorAll('.currency-selector__select').forEach(function(element) {
        element.addEventListener('change', currencyFormSubmit);
    });
});